// Utility per traduzioni con placeholder
function t(key, vars = {}) {
  let str = window.sampleTranslations?.[key] || '';
  return Object.keys(vars).reduce(
    (acc, k) => acc.replaceAll(`{${k}}`, vars[k]),
    str
  );
}

class ProductSample {
  constructor() {
    this.currentVariantId = null;
    this.productData = null;
    this.maxQuantityPerSession = 3; // Limite massimo per sessione
    this.sessionStorageKey = 'sample_products_session';
    this.init();
  }

  init() {
    console.log('Inizializzazione ProductSample...');
    this.bindEvents();
    
    // Verifica che ci siano elementi sample nella pagina
    const sampleLinks = document.querySelectorAll('.sample-link');
    console.log('Sample links trovati:', sampleLinks.length);
    
    if (sampleLinks.length === 0) {
      console.warn('Nessun sample link trovato nella pagina');
    }
  }

  bindEvents() {
    console.log('Binding eventi...');
    
    // Gestione click sul link campione
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('sample-link')) {
        e.preventDefault();
        console.log('Click su sample link rilevato');
        this.handleLinkClick(e.target);
      }
    });

    // Gestione chiusura popup
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('sample-popup-close') || 
          e.target.classList.contains('sample-popup-overlay')) {
        console.log('Click chiusura popup rilevato');
        this.closePopup();
      }
    });

    // Gestione cambio opzioni varianti
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('sample-option-select')) {
        console.log('Cambio variante rilevato');
        this.handleVariantChange();
      }
    });

    // Gestione form add to cart
    document.addEventListener('submit', (e) => {
      if (e.target.classList.contains('sample-product-form')) {
        e.preventDefault();
        console.log('Submit form campione rilevato');
        this.handleAddToCart(e.target);
      }
    });

    // Chiusura popup con ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closePopup();
      }
    });
    
    console.log('Eventi bindati con successo');
  }

  async handleLinkClick(link) {
    console.log('Gestione click link:', link);
    const popup = link.closest('.product-sample-block').querySelector('.sample-popup-overlay');
    console.log('Popup trovato:', popup);
    await this.openPopup(popup);
  }

  async openPopup(popup) {
    console.log('Tentativo apertura popup:', popup);
    
    if (popup) {
      // Carica i dati del prodotto
      this.loadProductData(popup);
      
      popup.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      
      console.log('Popup aperto con successo');
      
      // Focus sul popup per accessibilità
      setTimeout(() => {
        const closeBtn = popup.querySelector('.sample-popup-close');
        if (closeBtn) closeBtn.focus();
      }, 100);
    } else {
      console.error('Popup non trovato!');
    }
  }

  closePopup() {
    console.log('Chiusura popup...');
    const popup = document.querySelector('.sample-popup-overlay[style*="flex"]');
    if (popup) {
      popup.style.display = 'none';
      document.body.style.overflow = '';
      console.log('Popup chiuso');
    }
  }

  async loadProductData(popup) {
    const productDataScript = popup.querySelector('.sample-product-data');
    if (productDataScript) {
      try {
        this.productData = JSON.parse(productDataScript.textContent);
        this.buildVariantSelectors(popup);
        await this.updateSessionWarning(popup);
      } catch (error) {
        console.error('Errore nel parsing dei dati prodotto:', error);
        this.showError(popup, 'Errore nel caricamento del prodotto');
      }
    }
  }

  // Ottiene la quantità di una specifica variante nel carrello
  async getVariantQuantityInCart(variantId) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      let totalQuantity = 0;
      
      cart.items.forEach(item => {
        if (item.variant_id === variantId) {
          totalQuantity += item.quantity;
        }
      });
      
      console.log(`Quantità variante ${variantId} nel carrello:`, totalQuantity);
      return totalQuantity;
      
    } catch (error) {
      console.error('Errore nel recupero del carrello:', error);
      return 0;
    }
  }

  // Ottiene la quantità della prima variante già nel carrello per questa sessione
  async getFirstVariantQuantityInSession() {
    const firstVariant = this.productData?.variants?.[0];
    if (!firstVariant) return 0;
    
    try {
      // Ottieni il carrello attuale via AJAX
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Cerca la prima variante nel carrello
      let totalQuantity = 0;
      cart.items.forEach(item => {
        // Controlla se questo item è la prima variante del nostro prodotto
        if (item.variant_id === firstVariant.id) {
          // Verifica anche se ha la proprietà che indica che è un campione
          const hasSampleProperty = item.properties && (
            item.properties['Prodotto campione'] || 
            item.properties['Gratuita'] === 'Sì'
          );
          
          if (hasSampleProperty) {
            totalQuantity += item.quantity;
            console.log('Prima variante trovata nel carrello:', item.title, 'quantità:', item.quantity);
          }
        }
      });
      
      console.log('Quantità totale prima variante nel carrello:', totalQuantity);
      return totalQuantity;
      
    } catch (error) {
      console.error('Errore nel recupero del carrello:', error);
      // Fallback: usa sessionStorage come backup
      const sessionData = this.getSessionData();
      const key = `first_variant_${firstVariant.id}`;
      return sessionData[key] || 0;
    }
  }

  // Aggiorna la quantità della prima variante nella sessione
  updateFirstVariantQuantityInSession(quantity) {
    const sessionData = this.getSessionData();
    const firstVariant = this.productData?.variants?.[0];
    if (!firstVariant) return;
    
    // La chiave usa solo l'ID della prima variante
    const key = `first_variant_${firstVariant.id}`;
    sessionData[key] = (sessionData[key] || 0) + quantity;
    this.saveSessionData(sessionData);
  }

  // Ottiene i dati della sessione
  getSessionData() {
    const data = sessionStorage.getItem(this.sessionStorageKey);
    return data ? JSON.parse(data) : {};
  }

  // Salva i dati della sessione
  saveSessionData(data) {
    sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(data));
  }

  // Aggiorna il messaggio di avviso sulla sessione
async updateSessionWarning(popup) {
  const warningContainer = popup.querySelector('.sample-session-warning');
  if (!warningContainer) return;
  
  // Trova la variante corrente
  const currentVariant = this.productData?.variants?.find(v => v.id === this.currentVariantId);
  if (!currentVariant) {
    warningContainer.innerHTML = '';
    return;
  }
  
  let warningHtml = '';
  const addButton = popup.querySelector('.sample-add-to-cart-btn');
  const quantityInput = popup.querySelector('#sample-quantity');
  
  // Controlla se la variante ha un limite di acquisto
  if (currentVariant.purchaseLimit) {
    const currentQuantityInCart = await this.getVariantQuantityInCart(this.currentVariantId);
    const remaining = Math.max(0, currentVariant.purchaseLimit - currentQuantityInCart);
    
    if (remaining === 0) {
      const message = window.purchaseLimitTranslations?.limitReached?.replace('{{ limit }}', currentVariant.purchaseLimit) || 
                      `Hai già raggiunto il limite massimo di ${currentVariant.purchaseLimit} unità per questa variante`;
      warningHtml = `<div class="sample-warning sample-warning--error">${message}</div>`;
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = window.purchaseLimitTranslations?.limitReachedButton || 'Limite raggiunto';
      }
      if (quantityInput) {
        quantityInput.disabled = true;
        quantityInput.max = 0;
        quantityInput.value = 0;
      }
    } else {
      let message = window.purchaseLimitTranslations?.purchaseLimitInfo || 
                    'Limite di acquisto: {{ limit }} unità<br>Già nel carrello: {{ current }}<br>Puoi ancora aggiungere: {{ remaining }} unità';
      message = message.replace('{{ limit }}', currentVariant.purchaseLimit)
                       .replace('{{ current }}', currentQuantityInCart)
                       .replace('{{ remaining }}', remaining);
      warningHtml = `<div class="sample-warning sample-warning--info">${message}</div>`;
      if (addButton) {
        addButton.disabled = false;
        addButton.textContent = 'Aggiungi al carrello';
      }
      if (quantityInput) {
        quantityInput.disabled = false;
        quantityInput.max = remaining;
        if (parseInt(quantityInput.value) > remaining) {
          quantityInput.value = remaining;
        }
      }
    }
  } else {
    // Nessun limite per questa variante
    warningHtml = '';
    if (addButton) {
      addButton.disabled = false;
      addButton.textContent = 'Aggiungi al carrello';
    }
    if (quantityInput) {
      quantityInput.disabled = false;
      quantityInput.max = 999;
    }
  }
  
  warningContainer.innerHTML = warningHtml;
  return;
  
  // Il codice sotto non verrà mai eseguito ora
  const firstVariant = this.productData?.variants?.[0];
  if (!firstVariant) return;
  
  const currentQuantity = await this.getFirstVariantQuantityInSession();
  const remaining = this.maxQuantityPerSession - currentQuantity;
  const isFirstVariantSelected = this.currentVariantId === firstVariant.id;

  if (isFirstVariantSelected) {
    if (remaining <= 0) {
      warningHtml = `<div class="sample-warning sample-warning--error">
        ${t('limitReachedFirstVariant', { variant: firstVariant.title })}
      </div>`;
      const addButton = popup.querySelector('.sample-add-to-cart-btn');
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = t('limitReachedButton');
      }
      const quantityInput = popup.querySelector('#sample-quantity');
      if (quantityInput) {
        quantityInput.disabled = true;
        quantityInput.max = 0;
      }
    } else {
      warningHtml = `<div class="sample-warning sample-warning--info">
        ${t('sessionLimitFirstVariant', {
          variant: firstVariant.title,
          max: this.maxQuantityPerSession,
          current: currentQuantity,
          remaining
        })}
      </div>`;
      const quantityInput = popup.querySelector('#sample-quantity');
      if (quantityInput) {
        quantityInput.max = remaining;
        if (parseInt(quantityInput.value) > remaining) {
          quantityInput.value = remaining;
        }
      }
    }
  } else {
    warningHtml = `<div class="sample-warning sample-warning--info">
      ${t('noLimitOtherVariants', {
        max: this.maxQuantityPerSession,
        variant: firstVariant.title
      })}
    </div>`;
    const addButton = popup.querySelector('.sample-add-to-cart-btn');
    if (addButton) {
      addButton.disabled = false;
      addButton.textContent = t('addToCart') || 'Aggiungi al carrello';
    }
    const quantityInput = popup.querySelector('#sample-quantity');
    if (quantityInput) {
      quantityInput.disabled = false;
      quantityInput.max = 999;
    }
  }

  warningContainer.innerHTML = warningHtml;
}

  buildVariantSelectors(popup) {
    const container = popup.querySelector('.sample-variants-container');
    const loadingDiv = container.querySelector('.variants-loading');
    
    if (!this.productData || !this.productData.variants) {
      this.showError(popup, 'Dati prodotto non disponibili');
      return;
    }

    console.log('Costruzione selettori varianti per:', this.productData.title);
    console.log('Varianti disponibili:', this.productData.variants);
    console.log('Opzioni prodotto:', this.productData.options);

    // Rimuovi il loading
    if (loadingDiv) {
      loadingDiv.remove();
    }

    // Se c'è solo una variante disponibile
    const availableVariants = this.productData.variants.filter(v => v.available);
    console.log('Varianti disponibili filtrate:', availableVariants);
    
    if (availableVariants.length === 0) {
      this.showError(popup, 'Nessuna variante disponibile');
      return;
    }
    
    if (availableVariants.length === 1) {
      console.log('Una sola variante disponibile:', availableVariants[0]);
      this.currentVariantId = availableVariants[0].id;
      this.updatePrice(availableVariants[0].price);
      this.updateAddToCartButton(true);
      container.innerHTML = '<input type="hidden" name="id" value="' + this.currentVariantId + '">';
      return;
    }

    // Se ci sono più opzioni, costruisci i selettori
    if (this.productData.options && this.productData.options.length > 0 && this.productData.options.length <= 3) {
      console.log('Costruzione selettori per opzioni multiple');
      this.buildOptionSelectors(container);
    } else {
      console.log('Costruzione select semplice');
      // Fallback: costruisci una select semplice con tutte le varianti
      this.buildSimpleVariantSelect(container);
    }
  }

  buildOptionSelectors(container) {
    container.innerHTML = '';
    
    console.log('Costruzione selettori per opzioni:', this.productData.options);
    
    this.productData.options.forEach((option, index) => {
      const optionDiv = document.createElement('div');
      optionDiv.className = 'sample-variant-option';
      
      const label = document.createElement('label');
      label.textContent = option.name + ':';
      optionDiv.appendChild(label);
      
      const select = document.createElement('select');
      select.className = 'sample-option-select';
      select.dataset.optionPosition = index + 1;
      
      console.log('Creazione select per opzione:', option.name, 'posizione:', index + 1);
      
      // Aggiungi placeholder
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Seleziona ' + option.name;
      placeholder.disabled = true;
      placeholder.selected = true;
      select.appendChild(placeholder);
      
      option.values.forEach(value => {
        const optionElement = document.createElement('option');
        optionElement.value = value;
        optionElement.textContent = value;
        select.appendChild(optionElement);
        console.log('Aggiunto valore opzione:', value);
      });
      
      optionDiv.appendChild(select);
      container.appendChild(optionDiv);
    });

    // Aggiungi input nascosto per l'ID variante
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'id';
    hiddenInput.className = 'variant-id-input';
    container.appendChild(hiddenInput);
    
    console.log('Selettori opzioni costruiti');
  }

  buildSimpleVariantSelect(container) {
    container.innerHTML = '';
    
    console.log('Costruzione select semplice per varianti');
    
    const label = document.createElement('label');
    label.textContent = 'Variante:';
    container.appendChild(label);
    
    const select = document.createElement('select');
    select.className = 'sample-option-select';
    select.name = 'id';
    
    // Placeholder
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Seleziona variante';
    placeholder.disabled = true;
    placeholder.selected = true;
    select.appendChild(placeholder);
    
    this.productData.variants.forEach(variant => {
      if (variant.available) {
        const option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.title + ' - ' + this.formatMoney(variant.price);
        option.dataset.price = variant.price;
        select.appendChild(option);
        console.log('Aggiunta variante:', variant.title, variant.id);
      }
    });
    
    container.appendChild(select);
    console.log('Select semplice costruita');
  }

  async handleVariantChange() {
    const popup = document.querySelector('.sample-popup-overlay[style*="flex"]');
    if (!popup || !this.productData) return;

    const selects = popup.querySelectorAll('.sample-option-select');
    const selectedOptions = {};
    let allSelected = true;

    console.log('Gestione cambio varianti, selects trovati:', selects.length);

    // Raccogli tutte le opzioni selezionate
    selects.forEach(select => {
      const position = select.dataset.optionPosition;
      console.log('Select position:', position, 'value:', select.value);
      
      if (position) {
        selectedOptions[`option${position}`] = select.value;
        if (!select.value) allSelected = false;
      } else {
        // Select semplice con ID variante diretto
        if (select.value) {
          this.currentVariantId = parseInt(select.value);
          const variant = this.productData.variants.find(v => v.id === this.currentVariantId);
          if (variant) {
            console.log('Variante selezionata (select semplice):', variant);
            this.updatePrice(variant.price);
            this.updateAddToCartButton(true);
          }
        } else {
          allSelected = false;
        }
        return;
      }
    });

    console.log('Opzioni selezionate:', selectedOptions, 'Tutte selezionate:', allSelected);

    if (allSelected && Object.keys(selectedOptions).length > 0) {
      // Trova la variante corrispondente
      const matchingVariant = this.productData.variants.find(variant => {
        const match = Object.keys(selectedOptions).every(key => {
          return variant[key] === selectedOptions[key];
        });
        console.log('Controllo variante:', variant.title, 'Match:', match, {
          variant_options: Object.keys(selectedOptions).map(key => variant[key]),
          selected_options: Object.values(selectedOptions)
        });
        return match;
      });

      console.log('Variante trovata:', matchingVariant);

      if (matchingVariant && matchingVariant.available) {
        this.currentVariantId = matchingVariant.id;
        this.updatePrice(matchingVariant.price);
        this.updateAddToCartButton(true);
        
        // Aggiorna l'input nascosto
        const hiddenInput = popup.querySelector('.variant-id-input');
        if (hiddenInput) {
          hiddenInput.value = this.currentVariantId;
        }
        
        // Aggiorna l'avviso di sessione quando cambia la variante
        await this.updateSessionWarning(popup);
        
        console.log('Variante impostata:', {
          id: this.currentVariantId,
          title: matchingVariant.title,
          price: matchingVariant.price
        });
      } else {
        console.log('Variante non disponibile o non trovata');
        this.currentVariantId = null;
        this.updateAddToCartButton(false, 'Variante non disponibile');
      }
    } else {
      console.log('Non tutte le opzioni sono selezionate');
      this.currentVariantId = null;
      this.updateAddToCartButton(false);
    }
  }

  updatePrice(price) {
    const popup = document.querySelector('.sample-popup-overlay[style*="flex"]');
    if (popup) {
      const priceElement = popup.querySelector('.variant-price');
      if (priceElement) {
        const formattedPrice = this.formatMoney(price);
        priceElement.textContent = formattedPrice;
        console.log('Prezzo aggiornato:', formattedPrice, 'da', price, 'centesimi');
      } else {
        console.warn('Elemento prezzo non trovato');
      }
    }
  }

  updateAddToCartButton(enabled, text = null) {
    const popup = document.querySelector('.sample-popup-overlay[style*="flex"]');
    if (popup) {
      const button = popup.querySelector('.sample-add-to-cart-btn');
      if (button) {
        button.disabled = !enabled;
        if (text) {
          button.textContent = text;
        } else {
          button.textContent = enabled ? 'Aggiungi al carrello' : 'Seleziona variante';
        }
      }
    }
  }

  async handleAddToCart(form) {
    const submitBtn = form.querySelector('.sample-add-to-cart-btn');
    const originalText = submitBtn.textContent;
    
    // Verifica che sia selezionata una variante
    if (!this.currentVariantId) {
      const variantIdInput = form.querySelector('input[name="id"]');
      if (variantIdInput && variantIdInput.value) {
        this.currentVariantId = parseInt(variantIdInput.value);
      } else {
        this.showError(form.closest('.sample-popup'), t('selectVariant') || 'Seleziona una variante');
        return;
      }
    }

    const formData = new FormData(form);
    const quantity = parseInt(formData.get('quantity')) || 1;

    // Trova la variante corrente nei dati del prodotto
    const currentVariant = this.productData?.variants?.find(v => v.id === this.currentVariantId);
    if (!currentVariant) {
      this.showError(form.closest('.sample-popup'), 'Variante non trovata');
      return;
    }

    // Controlla se la variante ha un limite di acquisto
    if (currentVariant.purchaseLimit) {
      const currentQuantityInCart = await this.getVariantQuantityInCart(this.currentVariantId);
      
      console.log('=== CONTROLLO LIMITE VARIANTE ===');
      console.log('Variante:', currentVariant.title);
      console.log('Limite di acquisto:', currentVariant.purchaseLimit);
      console.log('Quantità già nel carrello:', currentQuantityInCart);
      console.log('Quantità che si vuole aggiungere:', quantity);
      console.log('Totale dopo aggiunta:', currentQuantityInCart + quantity);
      
      if (currentQuantityInCart + quantity > currentVariant.purchaseLimit) {
        const remaining = Math.max(0, currentVariant.purchaseLimit - currentQuantityInCart);
        let errorMsg;
        
        if (remaining === 0) {
          errorMsg = window.purchaseLimitTranslations?.limitReached?.replace('{{ limit }}', currentVariant.purchaseLimit) || 
                    `Hai già raggiunto il limite massimo di ${currentVariant.purchaseLimit} unità per questa variante`;
        } else {
          errorMsg = window.purchaseLimitTranslations?.canOnlyAdd?.replace('{{ remaining }}', remaining).replace('{{ limit }}', currentVariant.purchaseLimit) || 
                    `Puoi aggiungere solo ${remaining} unità di questa variante (limite: ${currentVariant.purchaseLimit})`;
        }
        
        console.log('LIMITE RAGGIUNTO! Bloccando aggiunta.');
        this.showError(form.closest('.sample-popup'), errorMsg);
        return;
      }
    }

    // Verifica il limite di sessione SOLO se stiamo aggiungendo la PRIMA variante
    const firstVariant = this.productData?.variants?.[0];
    if (firstVariant && this.currentVariantId === firstVariant.id) {
      // Stiamo aggiungendo la prima variante, quindi controlliamo il limite
      const currentSessionQuantity = this.getFirstVariantQuantityInSession(this.productData.id);
      const remainingQuantity = this.maxQuantityPerSession - currentSessionQuantity;
      
      console.log('Controllo limite sessione per PRIMA VARIANTE:');
      console.log('- Prima variante ID:', firstVariant.id);
      console.log('- Variante selezionata ID:', this.currentVariantId);
      console.log('- Prima variante:', firstVariant.title);
      console.log('- Quantità in sessione:', currentSessionQuantity);
      console.log('- Quantità rimanente:', remainingQuantity);
      console.log('- Quantità richiesta:', quantity);
      
      if (quantity > remainingQuantity) {
        const errorMsg = (window.sampleTranslations?.exceedsLimit || 'Puoi acquistare solo {remaining} campioni aggiuntivi in questa sessione.').replace('{remaining}', remainingQuantity);
        this.showError(form.closest('.sample-popup'), t('exceedsLimit', { remaining: remainingQuantity }));
        return;
      }

      if (remainingQuantity <= 0) {
        this.showError(form.closest('.sample-popup'), t('limitReached'));
        return;
      }
    } else if (firstVariant) {
      console.log('Variante selezionata NON è la prima - nessun limite applicato');
      console.log('- Prima variante ID:', firstVariant.id);
      console.log('- Variante selezionata ID:', this.currentVariantId);
    }

    // Ottieni i dati del prodotto corrente dalla pagina
    const popup = form.closest('.sample-popup-overlay');
    const link = popup.closest('.product-sample-block').querySelector('.sample-link');
    const currentProductSku = link.dataset.currentProductSku;

    try {
      // Stato loading
      submitBtn.classList.add('loading');
      submitBtn.textContent = t('adding') || 'Aggiunta in corso...';
      submitBtn.disabled = true;

      // Prepara i dati per l'aggiunta al carrello con property semplice
      const cartData = {
        id: this.currentVariantId,
        quantity: quantity,
        properties: {
          'SKU': currentProductSku || ''
        }
      };

      console.log('Aggiunta prodotto campione al carrello:', cartData);

      // Aggiungi al carrello
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(cartData)
      });

      const responseData = await response.json();

      if (response.ok) {
        // Successo - aggiorna il contatore di sessione per la PRIMA variante
        const firstVariant = this.productData?.variants?.[0];
        if (firstVariant && this.currentVariantId === firstVariant.id) {
          this.updateFirstVariantQuantityInSession(quantity);
        }
        
        submitBtn.textContent = t('added') || 'Aggiunto!';
        submitBtn.style.backgroundColor = '#28a745';
        
        console.log('Prodotto aggiunto con successo');
        
        // AGGIORNAMENTO IMMEDIATO DEL CONTATORE
        this.updateCartCountImmediately();
        
        // Aggiornamento completo del carrello
        setTimeout(async () => {
          await this.updateCartCount();
        }, 500);
        
        // Secondo tentativo più aggressivo
        setTimeout(() => {
          this.forceCartRefresh();
        }, 1500);
        
        // Chiudi il popup
        setTimeout(() => {
          this.closePopup();
          this.resetButton(submitBtn, originalText);
        }, 2000);

        // Eventi immediati
        this.triggerImmediateEvents(quantity);
        
      } else {
        console.error('Errore risposta server:', responseData);
        throw new Error(responseData.message || responseData.description || window.sampleTranslations?.addToCartError || 'Errore nell\'aggiunta al carrello');
      }

    } catch (error) {
      console.error('Errore:', error);
      submitBtn.textContent = t('errorRetry') || 'Errore - Riprova';
      submitBtn.style.backgroundColor = '#dc3545';
      
      setTimeout(() => {
        this.resetButton(submitBtn, originalText);
      }, 2000);
    }
  }

  // Aggiornamento IMMEDIATO del contatore (senza fetch)
  updateCartCountImmediately() {
    console.log('Aggiornamento immediato contatore carrello');
    
    // Selettori per contatori carrello
    const cartSelectors = [
      '.cart-count', '[data-cart-count]', '.cart-item-count', 
      '.cart__count', '#CartCount', '.header__icon--cart .visually-hidden',
      '.cart-count-bubble', '.cart__badge', '[data-cart-count-bubble]',
      '.cart-link__bubble', '.site-header__cart-count', '.header-cart-count',
      '[data-cart-item-count]', '.js-cart-item-count'
    ];
    
    cartSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        const currentCount = parseInt(element.textContent) || 0;
        const newCount = currentCount + 1;
        element.textContent = newCount;
        
        // Aggiorna data attributes
        if (element.hasAttribute('data-cart-count')) {
          element.setAttribute('data-cart-count', newCount);
        }
        
        // Mostra badge se era nascosto
        if (element.classList.contains('hidden')) {
          element.classList.remove('hidden');
        }
        element.style.display = '';
        
        console.log(`Contatore aggiornato immediatamente: ${selector} = ${newCount}`);
      });
    });
    
    // Mostra tutti i badge del carrello
    const badgeSelectors = ['.cart-count-bubble', '.cart__badge', '.cart-link__bubble'];
    badgeSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(badge => {
        badge.style.display = '';
        badge.classList.remove('hidden', 'hide');
        badge.classList.add('show');
      });
    });
  }

  // Eventi immediati senza fetch
  triggerImmediateEvents(quantity) {
    console.log('Trigger eventi immediati');
    
    const immediateEvents = [
      'cart:updated',
      'cart:item-added', 
      'shopify:cart:item:added',
      'theme:cart:add'
    ];

    immediateEvents.forEach(eventName => {
      document.dispatchEvent(new CustomEvent(eventName, {
        detail: { 
          variant_id: this.currentVariantId,
          quantity: quantity,
          source: 'product-sample-immediate'
        },
        bubbles: true
      }));
    });
    
    // Callback immediati
    if (window.Shopify && window.Shopify.onCartUpdate) {
      // Simula un oggetto carrello con contatore aggiornato
      const mockCart = { item_count: this.getCurrentCartCount() + quantity };
      window.Shopify.onCartUpdate(mockCart);
    }
  }

  // Ottiene il contatore corrente del carrello
  getCurrentCartCount() {
    const counterElement = document.querySelector('.cart-count, [data-cart-count], .cart-item-count');
    return counterElement ? parseInt(counterElement.textContent) || 0 : 0;
  }

  // Refresh forzato del carrello con tutti i metodi possibili
  forceCartRefresh() {
    console.log('Refresh forzato del carrello');
    
    try {
      // Metodo 1: Click su link carrello per forzare refresh
      const cartLinks = document.querySelectorAll('a[href*="/cart"], .cart-link, [data-cart-drawer-toggle]');
      if (cartLinks.length > 0) {
        console.log('Simulazione click su cart link per refresh');
        // Non facciamo click reale, ma triggeriamo l'evento
        cartLinks[0].dispatchEvent(new Event('mouseenter', { bubbles: true }));
      }
      
      // Metodo 2: Forza refresh drawer se aperto
      const openDrawers = document.querySelectorAll('.cart-drawer.active, .cart-drawer.open, #CartDrawer.active');
      if (openDrawers.length > 0) {
        console.log('Drawer aperto trovato, forzando refresh');
        this.updateCartCount();
      }
      
      // Metodo 3: Trigger eventi window-level
      window.dispatchEvent(new CustomEvent('cart:forceUpdate'));
      window.dispatchEvent(new Event('resize')); // Alcuni temi si aggiornano su resize
      
      // Metodo 4: Callback tema se presente
      if (window.theme && window.theme.cart && typeof window.theme.cart.refresh === 'function') {
        console.log('Usando theme.cart.refresh');
        window.theme.cart.refresh();
      }
      
    } catch (error) {
      console.error('Errore durante force refresh:', error);
    }
  }

  async updateCartCount() {
    try {
      console.log('Aggiornamento carrello completo...');
      
      // Fetch del carrello aggiornato
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      console.log('Carrello ricevuto:', cart);
      
      // Aggiorna contatori con il valore reale
      const cartSelectors = [
        '.cart-count', '[data-cart-count]', '.cart-item-count', 
        '.cart__count', '#CartCount', '.header__icon--cart .visually-hidden',
        '.cart-count-bubble', '.cart__badge', '[data-cart-count-bubble]',
        '.cart-link__bubble', '.site-header__cart-count', '.header-cart-count',
        '[data-cart-item-count]', '.js-cart-item-count'
      ];
      
      cartSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          element.textContent = cart.item_count;
          if (element.hasAttribute('data-cart-count')) {
            element.setAttribute('data-cart-count', cart.item_count);
          }
        });
      });

      // Aggiorna cart drawer
      await this.updateCartDrawer(cart);

      // Trigger eventi finali
      this.triggerAllCartEvents(cart);

    } catch (error) {
      console.error('Errore aggiornamento carrello completo:', error);
    }
  }

  async updateCartDrawer(cart) {
    console.log('Tentativo aggiornamento cart drawer...');
    
    try {
      // Metodo 1: Temi Dawn/moderni con cartDrawer object
      if (window.cartDrawer && typeof window.cartDrawer.renderContents === 'function') {
        console.log('Usando window.cartDrawer.renderContents');
        await window.cartDrawer.renderContents(cart);
        return;
      }

      // Metodo 2: Tema Dawn con theme object
      if (window.theme && window.theme.cartDrawer && typeof window.theme.cartDrawer.refresh === 'function') {
        console.log('Usando window.theme.cartDrawer.refresh');
        window.theme.cartDrawer.refresh();
        return;
      }

      // Metodo 3: Shopify Ajax API per sezioni
      const cartDrawerSection = document.querySelector('[data-section-type="cart-drawer"], [data-section-id*="cart-drawer"]');
      if (cartDrawerSection) {
        const sectionId = cartDrawerSection.dataset.sectionId || cartDrawerSection.id;
        if (sectionId) {
          console.log('Aggiornamento via Shopify Sections API:', sectionId);
          const sectionsResponse = await fetch(`/?sections=${sectionId}`);
          if (sectionsResponse.ok) {
            const sections = await sectionsResponse.json();
            if (sections[sectionId]) {
              cartDrawerSection.innerHTML = sections[sectionId];
              console.log('Cart drawer aggiornato via API');
              return;
            }
          }
        }
      }

      // Metodo 4: Fetch contenuto drawer via ?view=drawer
      const cartDrawers = document.querySelectorAll('.cart-drawer, #CartDrawer, [data-cart-drawer]');
      if (cartDrawers.length > 0) {
        console.log('Tentativo aggiornamento via cart?view=drawer');
        const drawerResponse = await fetch('/cart?view=drawer');
        if (drawerResponse.ok) {
          const drawerHTML = await drawerResponse.text();
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = drawerHTML;
          
          cartDrawers.forEach(drawer => {
            const contentSelectors = ['.cart-drawer__content', '.drawer__content', '.cart__items'];
            for (const selector of contentSelectors) {
              const existingContent = drawer.querySelector(selector);
              const newContent = tempDiv.querySelector(selector);
              if (existingContent && newContent) {
                existingContent.innerHTML = newContent.innerHTML;
                console.log('Contenuto drawer aggiornato:', selector);
                break;
              }
            }
          });
        }
      }

      console.log('Metodi di aggiornamento drawer completati');

    } catch (error) {
      console.error('Errore nell\'aggiornamento del cart drawer:', error);
    }
  }

  triggerAllCartEvents(cart) {
    console.log('Triggering eventi carrello finali...');
    
    const events = [
      'cart:updated',
      'cart:refresh', 
      'cart:change',
      'shopify:cart:update',
      'theme:cart:update',
      'drawer:refresh'
    ];

    events.forEach(eventName => {
      document.dispatchEvent(new CustomEvent(eventName, {
        detail: { cart: cart, source: 'product-sample' },
        bubbles: true
      }));
    });

    // Callback globali
    if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
      window.Shopify.onCartUpdate(cart);
    }
    
    if (window.jQuery) {
      window.jQuery(document).trigger('cart.updated', [cart]);
    }
  }

  getCurrentVariantTitle() {
    if (!this.currentVariantId || !this.productData) {
      return 'Variante sconosciuta';
    }
    
    const currentVariant = this.productData.variants.find(v => v.id === this.currentVariantId);
    return currentVariant ? currentVariant.title : 'Variante sconosciuta';
  }

  showError(popup, message) {
    const errorContainer = popup.querySelector('.sample-error-container');
    if (errorContainer) {
      errorContainer.innerHTML = `<div class="error-message" style="color: #dc3545; text-align: center; padding: 1rem;">${message}</div>`;
      errorContainer.style.display = 'block';
      setTimeout(() => {
        errorContainer.style.display = 'none';
      }, 5000);
    } else {
      const container = popup.querySelector('.sample-variants-container');
      container.innerHTML = `<div class="error-message" style="color: #dc3545; text-align: center; padding: 1rem;">${message}</div>`;
    }
  }

  resetButton(button, originalText) {
    button.classList.remove('loading');
    button.textContent = originalText;
    button.disabled = false;
    button.style.backgroundColor = '';
  }

  formatMoney(cents) {
    // Formattazione per Euro
    const euros = (cents / 100).toFixed(2);
    return `€${euros.replace('.', ',')}`;
  }
}

// Inizializza quando il DOM è pronto
document.addEventListener('DOMContentLoaded', () => {
  window.productSample = new ProductSample();
});

// Reinizializza se il contenuto viene caricato dinamicamente
document.addEventListener('shopify:section:load', () => {
  window.productSample = new ProductSample();
});